import { TApplicationState } from '../../types/redux';

export const getBuilderChatOpened = (state: TApplicationState): boolean => state.builderChat.isOpened;
